import React, { useState,useEffect,useCallback } from "react";
import Inputs from "../../components/inputs/Inputs";
import logo from "../../assets/images/taiPOS.png";
import "./login.css";
import Footer from "../../components/footer/Footer";

import { userLogin } from "../../app/authSlice";
import { resetMyPassword } from "../../app/userSlice";
import { useSelector,useDispatch } from "react-redux";
import Particles from 'react-particles';
import { loadFull } from "tsparticles";

import shopping from "../../assets/images/shopping.svg";
import boxProduct from "../../assets/images/boxProduct.svg";
import dawa from "../../assets/images/syrups.svg";
import tablet from "../../assets/images/tablet.svg";
import syringe from "../../assets/images/syringe.svg";
import bottle from "../../assets/images/bottle.svg";
import { loginSchema, resetPasswordSchema } from "../../common/validators";
import validate from "validate.js";
import { useNavigate } from "react-router-dom";

const Login = () => {
  // const auth = useSelector((state) => state.auth);
  const [errors, setErrors] = useState([]);
  const [showResetButton, setShowResetButton] = useState(true);
  const [formValues, setFormValues] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {auth} = useSelector((state) => state.auth);  
  const { error: passwordError, status: passwordStatus } = useSelector(
    ({ users }) => users.password
  );

  const backToRegister = (e) => {
    e.preventDefault();
    // window.location.replace("/register")
    navigate("/register");
  }

  const handleChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });
  };

  useEffect(() => {
    //alert(JSON.stringify(auth));
    if(auth?.data){
      localStorage.setItem('userData',JSON.stringify(auth?.data))
    }
  }, [auth]);

  useEffect(() => {
    //alert(JSON.stringify(auth));
    if(passwordStatus === 'loading'){
      setShowResetButton(false)
    }else
    if(passwordStatus === 'idle' && passwordError === null){
      setShowResetButton(true)
    }
    else
    if(passwordError){
      setShowResetButton(true)
    }
  }, [passwordStatus,passwordError]);

  const handleResetPassword = (e) => {
    e.preventDefault();
    let validationErrors = validate(
      formValues,
      resetPasswordSchema
    );

    if(validationErrors){
      setErrors(validationErrors);      
    }else{
      //alert("Work in Progress")
      dispatch(resetMyPassword(formValues))
    }

  }

  const submit = (e) => {
    e.preventDefault();
    let validationErrors = validate(
      formValues,
      loginSchema
    );


    if(validationErrors){
      setErrors(validationErrors);      
    }else{
      dispatch(
        userLogin({
          email: formValues.username,
          password: formValues.password,
        })
      );
    }

  };

  
  const particlesInit = useCallback(async (engine) => {
    //console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    //await console.log(container);
  }, []);


const myCanvas = <Particles 
id="tsparticles"
init={particlesInit}
loaded={particlesLoaded}
options={{
  fpsLimit: 320,
  "particles": {
     
      "line_linked": {
          "enable": true
      },
      links: {
        color: "#367588",
        distance: 150,
        enable: true,
        opacity: 0.5,
        width: 1,
      },
      collisions: {
        enable: true,
      },
      move: {
        directions: "none",
        enable: true,
        outModes: {
          default: "bounce",
        },
        random: false,
        speed: 1,
        straight: false,
      },
      number: {
        density: {
          enable: true,
          area: 800,
        },
        value: 30,
      },
      opacity: {
        value: 0.5,
      },
      "shape": {
          "type": [
              "image"
          ],
          "image": [
              {
                  "src": dawa,
                  "height": 5,
                  "width": 5
              },
              {
                "src": shopping,
                "height": 80,
                "width": 80
              },
              {
                "src": boxProduct,
                "height": 80,
                "width": 80
              },
              {
                  "src": bottle,
                  "height": 5,
                  "width": 5
              },
              {
                  "src": tablet,
                  "height": 5,
                  "width": 5
              },
              // {
              //   "src": syringe,
              //   "height": 5,
              //   "width": 5
              // }

          ]
      },
      "color": {
          "value": "#ffffff"
      },
      "size": {
          "value": 15,
          "random": false,
          "anim": {
              "enable": true,
              "speed": 4,
              "size_min": 10,
              "sync": false
          }
      }
  },
  "retina_detect": false
}} />


  //alert(localStorage.getItem('token'))
  return (
    <div className="login-page">
      <div style={{zIndex:"5 !íportant"}}>
      {myCanvas}
        </div>
       
      <div className="row">
        <div className="col-12">
          <img src={logo} alt="logo" height="80vh" />
          <div className="card" style={{backgroundColor:"#ffffff"}}>
            <h2 className="page-header">TaiPass</h2>
            <div
              className="card-body"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Inputs
                name="username"
                label="Username"
                className="input-class"
                size="small"
                value={formValues.username}
                inputType="text"
                onChange={handleChange}
                error={errors["username"] ? true : false}
                helperText={errors["username"] ? errors.username[0] : null}
              />
              <br />
              <Inputs
                name="password"
                label="Password"
                className="input-class"
                size="small"
                value={formValues.password}
                inputType="password"
                onChange={handleChange}
                error={errors["password"] ? true : false}
                helperText={errors["password"] ? errors.password[0] : null}
              />
              <br />
              {/* <Buttons 
              name="LOGIN"
              type="submit"
              
              /> */}
              <div id="forgot">
                {showResetButton === true ?
                  <a style={{ float: "right",cursor:"pointer" }} onClick={(e) => handleResetPassword(e)}>
                  Reset My Password
                </a> : ""}              
              </div> 
              <Inputs
                color="primary"
                size="medium"
                inputType="button"
                text="LOGIN"
                type="submit"
                onClick={(e) => submit(e)}
                propBackgroundColor={"#367588"}
              />
            </div>
                       
          </div>
        </div>
      </div>
      <div id="register" style={{ float: "center" }}>
          Don't you have an account? Click here to &nbsp;
          <b id="styleRegister" style={{ cursor: "pointer", color:"white" }} onClick={(e) => backToRegister(e)}>
            Register
          </b>
      </div>
      <div style={{ marginTop: "9vh" }}>
        <Footer />
      </div>
    </div>
  );
};

export default Login;
